import React, { useContext, useState } from "react";
import BottomBar from "components/bottom-bar";
import { Button } from "components/button";
import StoreShipmentModal from "components/store-shipment-modal";
import ShipmentItem from "components/shipment-item";
import { useGetShipments } from "api/tes/useGetShipments";
import AuthContext from "../../contexts/AuthContext";

export default function Shipping() {
  const { user } = useContext(AuthContext);
  const [modalOpen, setModalOpen] = useState(false);
  const { data: shipmentsData, isLoading, error } = useGetShipments(user.state);

  return (
    <div className="flex flex-col h-[calc(100vh-81px)]">
      <div className="flex flex-grow flex-col px-6 py-4 pb-48">
        <h1 className="text-6xl text-primary mb-regular">Shipments</h1>

        {/* Shipments list */}
        <div className="flex flex-col gap-4">
          {isLoading ? (
            <div className="bg-white border border-gray-200 rounded-lg p-4 shadow-sm">
              <p className="text-gray-600">Loading shipments...</p>
            </div>
          ) : error ? (
            <div className="bg-white border border-gray-200 rounded-lg p-4 shadow-sm">
              <p className="text-red-600">
                Error loading shipments: {error.message}
              </p>
            </div>
          ) : shipmentsData?.data?.shippingses?.items?.length > 0 ? (
            shipmentsData.data.shippingses.items.map((shipment) => (
              <ShipmentItem key={shipment.id} shipment={shipment} />
            ))
          ) : (
            <div className="bg-white border border-gray-200 rounded-lg p-4 shadow-sm">
              <h3 className="text-lg font-semibold text-gray-800 mb-2">
                Recent Shipments
              </h3>
              <p className="text-gray-600">
                No shipments found. Create a shipping label to get started.
              </p>
            </div>
          )}
        </div>
      </div>

      {/* Floating Create Shipping Label Button */}
      <div className="fixed bottom-32 left-6 right-6 z-10">
        <Button
          onClick={() => setModalOpen(true)}
          className="px-8 py-4 text-lg w-full shadow-lg"
        >
          Create Shipping Label
        </Button>
      </div>

      <BottomBar />

      {modalOpen && (
        <StoreShipmentModal modalOpen={modalOpen} setModalOpen={setModalOpen} />
      )}
    </div>
  );
}
